import { Link } from "react-router-dom";
import { FadeIn, FadeInStagger } from "../../components/utils/FadeIn";
import { PageHeading } from "../../components/utils/pageHeading";
import { ContactCTA } from "../../components/home/ContactCTA";
import { PromangLogo } from "../../components/utils/PromangLogo";
import { ResourceLoading } from "../../components/utils/ResourceLoading";
import { usePublicJobOpenings } from "../../hooks/usePublicJobOpenings";
import { formatJobDate, jobOpeningPath } from "../../data/jobOpeningPublic";

export const Stillinger = () => {
  const { items, loading, fromApi } = usePublicJobOpenings({ per_page: 50 });

  return (
    <>
      <PageHeading
        eyebrow="Karriere"
        title="Ledige stillinger."
        description="Vi bygger sterke serviceteam innen ventilasjon. Finn en rolle som passer deg — og søk direkte. Listen synkes fra Promang."
      />

      <section className="sec tint" style={{ borderTop: "none" }}>
        <div className="wrap">
          <div className="sec-head">
            <div className="sec-tag">Hos Airon</div>
            <h2>
              Kan en av disse <em>være noe for deg?</em>
            </h2>
            <div
              className="source-badge"
              aria-label="Synkroniseres fra Promang"
            >
              <span className="pulse" />
              <span style={{ fontFamily: "var(--mono)", fontSize: 11 }}>
                {loading
                  ? "Henter fra"
                  : fromApi
                    ? `${items.length} stillinger · synk fra`
                    : "Viser reserve · synk fra"}
              </span>
              <PromangLogo height={14} color="var(--airon-3)" />
            </div>
          </div>

          {loading ? (
            <div style={{ padding: "40px 0" }}>
              <ResourceLoading />
            </div>
          ) : items.length === 0 ? (
            <div
              style={{
                border: "1px dashed var(--line)",
                borderRadius: 20,
                padding: 40,
                background: "#fff",
                textAlign: "center",
              }}
            >
              <h2
                style={{
                  fontFamily: "var(--display)",
                  margin: 0,
                  fontSize: 28,
                }}
              >
                Ingen åpne stillinger akkurat nå
              </h2>
              <p style={{ color: "var(--ink-2)", marginTop: 10 }}>
                Send gjerne en åpen søknad via kontaktsiden.
              </p>
              <Link to="/kontakt" className="btn" style={{ marginTop: 18 }}>
                Kontakt oss <span className="arr">→</span>
              </Link>
            </div>
          ) : (
            <FadeInStagger>
              <div className="stilling-list">
                {items.map((job) => (
                  <FadeIn key={job.id || job.slug}>
                    <Link
                      to={job.path || jobOpeningPath(job)}
                      className="stilling-row"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      <div>
                        <div className="career-tags" style={{ marginBottom: 10 }}>
                          {(job.employment_type_label || job.employment_type) && (
                            <span className="career-chip">
                              {job.employment_type_label || job.employment_type}
                            </span>
                          )}
                          {job.location && (
                            <span className="career-chip muted">{job.location}</span>
                          )}
                          {job.application_deadline && (
                            <span className="career-chip accent">
                              Frist {formatJobDate(job.application_deadline)}
                            </span>
                          )}
                        </div>
                        <h2 className="career-title" style={{ fontSize: 24 }}>
                          {job.title}
                        </h2>
                        {job.short_description ? (
                          <p className="career-excerpt" style={{ marginTop: 8 }}>
                            {job.short_description}
                          </p>
                        ) : null}
                      </div>
                      <span className="career-more">Se stilling →</span>
                    </Link>
                  </FadeIn>
                ))}
              </div>
            </FadeInStagger>
          )}

          {!loading && items.length > 0 ? (
            <div
              style={{
                marginTop: 28,
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <a
                href="https://promang.no"
                target="_blank"
                rel="noreferrer noopener"
                title="Powered by Promang"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                  color: "var(--muted)",
                  textDecoration: "none",
                  fontFamily: "var(--mono)",
                  fontSize: 11,
                  letterSpacing: "0.06em",
                  textTransform: "uppercase",
                }}
              >
                <span>Powered by</span>
                <PromangLogo height={16} color="var(--ink-2)" />
              </a>
            </div>
          ) : null}
        </div>
      </section>

      <ContactCTA
        title="Ikke den rette stillingen"
        highlight="akkurat nå?"
        description="Send oss en åpen søknad — vi tar gjerne en prat om hva du kan bidra med."
        primary={{ label: "Kontakt oss", to: "/kontakt" }}
        secondary={{ label: "Om oss", to: "/om-oss" }}
      />
    </>
  );
};
